import * as React from 'react';

export function CamIcon({ size = 16 }: { size?: number }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
    >
      <path
        d="M4 7.5C4 6.11929 5.11929 5 6.5 5H13.5C14.8807 5 16 6.11929 16 7.5V16.5C16 17.8807 14.8807 19 13.5 19H6.5C5.11929 19 4 17.8807 4 16.5V7.5Z"
        stroke="currentColor"
        strokeWidth="1.8"
      />
      <path
        d="M16 10L20 7.8V16.2L16 14"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinejoin="round"
      />
    </svg>
  );
}

